/**
 * Datas de coluna DATE no painel.
 *
 * `new Date('2026-08-10')` é interpretado como meia-noite UTC e, em Brasília,
 * volta como 09/08 — o bug corrigido no PR #82 no backend. Aqui a data vem da
 * API como `YYYY-MM-DD` (ou `...T00:00:00.000Z`) e é formatada pelos
 * componentes da própria string, sem passar por `Date`.
 */

/** `YYYY-MM-DD` (ou ISO com hora) → `DD/MM/AAAA`. Entrada inválida volta vazia. */
export function formatarDataBR(data?: string | Date | null): string {
  const iso = paraISO(data);
  if (!iso) return '';
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano}`;
}

/** Normaliza para `YYYY-MM-DD`, cortando qualquer parte de hora/fuso. */
export function paraISO(data?: string | Date | null): string {
  if (!data) return '';
  if (data instanceof Date) {
    return [
      data.getFullYear(),
      String(data.getMonth() + 1).padStart(2, '0'),
      String(data.getDate()).padStart(2, '0'),
    ].join('-');
  }
  const texto = String(data).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(texto);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : '';
}

/** Hoje em `YYYY-MM-DD` pelos componentes LOCAIS — nunca `toISOString`. */
export function hojeISO(): string {
  return paraISO(new Date());
}

/**
 * A semana (segunda a domingo) que contém a data informada.
 *
 * Segunda como primeiro dia porque é assim que a creche planeja o cardápio —
 * `getDay()` devolve 0 para domingo, e usá-lo direto começaria a semana no fim
 * de semana.
 */
export function semanaDe(dataISO: string): { inicio: string; fim: string } {
  const [a, m, d] = paraISO(dataISO).split('-').map(Number);
  const base = new Date(Date.UTC(a, m - 1, d));
  const diaSemana = (base.getUTCDay() + 6) % 7; // 0 = segunda
  const inicio = new Date(base);
  inicio.setUTCDate(inicio.getUTCDate() - diaSemana);
  const fim = new Date(inicio);
  fim.setUTCDate(fim.getUTCDate() + 6);
  return {
    inicio: inicio.toISOString().slice(0, 10),
    fim: fim.toISOString().slice(0, 10),
  };
}
